export default __webpack_public_path__ + "static/media/4@2x.be8acc3f.png";